module.exports = __webpack_public_path__ + "static/media/Family.2a8f90dc.webp";